import React from "react";

function ProductSubmission() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4459_7153)">
        <path
          d="M11.5 19.0117V11.9688L4 8.21875V18.5312L10.375 21.7305L10.0117 23.2188L2.5 19.4688V6.53125L12.25 1.66797L22 6.53125V9.69531C21.4531 9.78125 20.9531 9.95703 20.5 10.2227V8.21875L13 11.9688V17.5117L11.5 19.0117ZM9.83594 4.53906L16.6797 8.45312L19.5742 7L12.25 3.33203L9.83594 4.53906ZM12.25 10.668L15.0625 9.26172L8.21875 5.34766L4.92578 7L12.25 10.668ZM22.6562 11.5C22.9844 11.5 23.2891 11.5586 23.5703 11.6758C23.8516 11.793 24.1016 11.9531 24.3203 12.1562C24.5391 12.3594 24.7031 12.6055 24.8125 12.8945C24.9219 13.1836 24.9844 13.4922 25 13.8203C25 14.125 24.9414 14.4219 24.8242 14.7109C24.707 15 24.5391 15.2539 24.3203 15.4727L15.918 23.875L11.5 24.9766L12.6016 20.5586L21.0039 12.168C21.2305 11.9414 21.4844 11.7734 21.7656 11.6641C22.0469 11.5547 22.3438 11.5 22.6562 11.5ZM23.2539 14.418C23.418 14.2539 23.5 14.0547 23.5 13.8203C23.5 13.5781 23.4219 13.3828 23.2656 13.2344C23.1094 13.0859 22.9062 13.0078 22.6562 13C22.5469 13 22.4414 13.0156 22.3398 13.0469C22.2383 13.0781 22.1484 13.1367 22.0703 13.2227L13.9609 21.332L13.5625 22.9141L15.1445 22.5156L23.2539 14.418Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_7153">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProductSubmission;
